import { EntitySampleRangeConfigurator, EntitySampleRangeValidator } from '../../common/EntitySampleRangeConfigurator';
import { EntityTextField } from '../../common/EntityTextField';
export const EntityTextPlugin = {
    type: 'text',
    edit: {
        field: EntityTextField
    },
    sampleData: {
        configurator: EntitySampleRangeConfigurator({
            minRange: { min: 0 },
            maxRange: { min: 0 }
        }),
        defaultValue: () => ({ min: 0, max: 1024 }),
        validate: EntitySampleRangeValidator
    }
};
//# sourceMappingURL=EntityTextPlugin.js.map